import { render, staticRenderFns } from "./BasketChart.vue?vue&type=template&id=571f47a4"
import script from "./BasketChart.vue?vue&type=script&lang=js"
export * from "./BasketChart.vue?vue&type=script&lang=js"
import style0 from "./BasketChart.vue?vue&type=style&index=0&id=571f47a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports